<template>
  <div class="search-page">
    <!-- Left Panel: Search Form -->
    <SearchFormPanel />

    <!-- Right Panel: Map -->
    <div class="map-panel d-none d-xl-block">
      <SearchMapWrapper v-if="pageUpdated" id="map-wrapper" class="map-wrapper"/>
      <MapLegend :isOutMap="true"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Capacitor } from '@capacitor/core'
import MapLegend from '@/components/map/MapLegend'
import SearchMapWrapper from '@/components/map/SearchMapWrapper'
import SearchFormPanel from '@/components/search/SearchFormPanel'

export default {
  name: 'Search',

  data: () => ({
    pageUpdated: false,
    resizeObserver: null,
  }),

  components: {
    MapLegend,
    SearchMapWrapper,
    SearchFormPanel,
  },

  created() {
    this.setHeights()
    // Skip the home-page garden prefetch on native platforms. The map panel that
    // consumes this data is hidden below the xl breakpoint (d-none d-xl-block),
    // so the fetch is wasted work on mobile AND — because it holds the shared
    // `loadingGardenList` lock — it races with the Search button's own
    // filterGardens dispatch, blocking navigation to /garden-list on iOS.
    if (!Capacitor.isNativePlatform()) {
      this.fetchAllGardens()
    }
    const headerHeight = document.querySelector('#header')
    if (headerHeight) {
      this.resizeObserver = new ResizeObserver(this.setHeights).observe(headerHeight)
    }
  },

  async mounted() {
    this.$nextTick(function () {
      this.pageUpdated = true
    })
  },

  updated() {
    this.setHeights()
  },

  methods: {
    ...mapActions('garden', [
      'fetchAllGardens',
    ]),

    setHeights() {
      this.$nextTick(function () {
        const headerHeight = document.querySelector('#header')?.offsetHeight || 0
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
        const availableHeight = vh - headerHeight

        // Set height for both panels
        const searchPage = document.querySelector('.search-page')
        if (searchPage) {
          searchPage.style.height = `${availableHeight}px`
        }

        const mapPanel = document.querySelector('.map-panel')
        if (mapPanel) {
          mapPanel.style.height = `${availableHeight}px`
        }

        const searchFormPanel = document.querySelector('.search-form-panel')
        if (searchFormPanel) {
          searchFormPanel.style.height = `${availableHeight}px`
        }

        const mapWrapper = document.querySelector('#map-wrapper')
        if (mapWrapper) {
          mapWrapper.style.height = `${availableHeight}px`
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.search-page {
  display: flex;
  width: 100%;
  overflow: hidden;
  position: relative;

  .map-panel {
    width: inherit;
    position: relative;
    background-color: #f5f5f5;

    .map-wrapper {
      width: 100%;
      height: 100%;
      position: relative;
    }
  }
}

@media (max-width: 1200px) {
  .search-page {
    flex-direction: column;

    .map-panel {
      width: 100%;
      min-height: 400px;
    }
  }
}
</style>
